import ZkUserInfo from './src/main'
ZkUserInfo.install = function (Vue) {
  Vue.component(ZkUserInfo.name, ZkUserInfo)
}
export default ZkUserInfo



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/loginUserInfo/index.js